import { useMutation, useQueryClient } from "@tanstack/react-query";
import carouselApi, { CAROUSEL_KEY, UploadCarouselParams } from "../../api/carouselApi";

export const useUpdateCarouselHomepage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: UploadCarouselParams;
    }) => carouselApi.updateCarousel(id, data),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CAROUSEL_KEY });
    },
  });
};